import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';

interface OverlayContextValue {
  isOverlayActive: boolean;
  showOverlay: () => void;
  hideOverlay: () => void;
}

const OverlayContext = createContext<OverlayContextValue | null>(null);

export function OverlayProvider({ children }: { children: ReactNode }) {
  const [isOverlayActive, setIsOverlayActive] = useState(false);

  const showOverlay = useCallback(() => setIsOverlayActive(true), []);
  const hideOverlay = useCallback(() => setIsOverlayActive(false), []);

  return (
    <OverlayContext.Provider value={{ isOverlayActive, showOverlay, hideOverlay }}>
      {children}
    </OverlayContext.Provider>
  );
}

export function useOverlay() {
  const context = useContext(OverlayContext);
  if (!context) {
    throw new Error('useOverlay must be used within OverlayProvider');
  }
  return context;
}
